/** Private account screens and tokenized participation URLs must not enter search results.
 * This is an indexing policy, never a substitute for authorization.
 */
export function isSearchExcluded(path: string): boolean {
  const pathname = path.split(/[?#]/, 1)[0];
  return /^(?:\/admin|\/account|\/auth|\/login|\/update-password|\/notifications|\/messages|\/follows|\/points)(?:\/|$)/.test(pathname)
    || /^\/(?:book-request|registry\/sign|consent-form\/fill|document-sign\/sign|lookup|exam-supervision\/p|unsubscribe)(?:\/|$)/.test(pathname)
    || /^\/timetable\/public(?:\/|$)/.test(pathname)
    || /^\/workmate\/(?:collect\/p|file-inbox\/u|training-certs\/upload)(?:\/|$)/.test(pathname)
    || /^\/classmate\/(?:sociometry\/s|quiz-battle\/live\/join|peer-quiz\/join|group-match\/join|secret16\/(?:join|play|result))(?:\/|$)/.test(pathname)
    || /^\/classmate\/(?:walls|albums)(?:\/|$)/.test(pathname)
    || /^\/classmate\/(?:wordcloud|buzzer|onepick)\/[^/]+\/(?:join|vote)(?:\/|$)/.test(pathname)
    || /^\/informate\/schools\/(?:ask|questions)(?:\/|$)/.test(pathname)
    || /^\/workmate\/school-conversation(?:\/|$)/.test(pathname)
    || /^\/community\/my(?:\/|$)/.test(pathname)
    || /\/(?:new|create|edit)(?:\/|$)/.test(pathname);
}
